'use strict'

export const TEMPLATES = {}
